<template>
  <div class="cpt-lottery-simple" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    }"
  >
    <div class="swiper-mask"></div>
    <div class="activity-list">
      <div class="swiper-container cpt-lottery-activity">
        <div class="swiper-wrapper">
          <div class="swiper-slide activity-item" v-for="topic,index in topic_list" :key="topic.topic_id" @click="handleJumpActivity(topic,index)">

            <img v-src="topic.img_url">
            <div class="locked-poster" v-if="index + 1 > cur_unlock_count">
              <div class="label">2月{{ index + 7 }}日 0:00开启</div>
              <div class="label">敬请期待</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="activity-dot">
      <div 
        class="dot-item"
        v-for="(topic, index) in topic_list" 
        :key="topic.topic_id"
        :class="{'active': active_index == index}"
      ></div>
    </div>
    <div class="btn-bottom-wrapper">
      <div class="btn-record" @click="getRecords"></div>
      <div class="btn-draw-box">
        <div class="btn-draw" :class="{ 'disable': !lottery_cnt }" @click="startLottery"></div>
        <div class="rest-count-desc">
          <p>剩余次数：{{ lottery_cnt }}</p>
        </div>
      </div>
      <div class="btn-award-pool" @click="showPrizeListModal"></div>
    </div>

    <Modal2 ref="prize-modal" width="calc(100vw - 60px)">
      <div class="prize-modal-wrapper">
        <img class="main-content" v-src="'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/award-modal-bg.png'" />
        <div class="prize-area">
          <img class="prize-bg" v-src="'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/award-bg.png'">
          <img class="prize-img" v-src="award.img_url"> 
          <div class="prize-name">
            <div class="text">{{ award.name }}</div>
          </div>
        </div>
        <div class="btn-done" @click="closePrizeModal">
          <img v-src="'https://static.max-c.com/static/heybox/webapp/activity/draw-lots-2024/confirm-btn.png'" />
        </div>
      </div>
    </Modal2>
    <!-- 中奖记录 -->
    <Modal2 ref="record-modal" width="calc(100vw - 60px)">
      <div class="record-wrapper">
        <img class="title-img" v-src="'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/record-title.png'">
        <img class="main-content" v-src="'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/modal-bg-v3.jpeg'" />
        <div class="record-content">
          <template v-if="record_list && record_list.length > 0">
            <div class="record-list">
              <div class="records colors">
                <div class="record-item" v-for="record in record_list" :key="record.timestamp">
                  <p class="desc" :style="{'color': gc.main_color}">获得</p>
                  <div class="prize-box" style="display: flex; align-items: center">
                    <div class="prize" :class="'color-' + record.rarity + ' border-color-' + record.rarity">
                      <p class="tag">{{['隐秘', '传说', '史诗', '稀有', '普通'][record.rarity-1]}}</p>
                      <p class="prize-name">{{record.name}}</p>
                    </div>
                  </div>
                  <p class="desc" :style="{'color': gc.main_color}">{{record.timestamp | formatTimestamp}}</p>
                </div>
              </div>
            </div>
            <p class="distribute-desc" :style="{'color': gc.main_color}">虚拟奖品已放入 我-黑盒商城-我的钱包</p>
          </template>
          <no-data v-else :color="gc.main_color" desc="暂时没有中奖记录"/>
        </div>
        <div class="btn-done" @click="closeRecordModal">
          <img v-src="'https://static.max-c.com/static/heybox/webapp/activity/draw-lots-2024/confirm-btn.png'" />
        </div>
      </div>
    </Modal2>
    <!-- 奖池大赏 -->
    <fade-modal ref="prize-list-modal" title="奖池大赏" :desc="cc.prize_list_desc" :gc="gc" :bg="gc.content_bg" :title_color="cc.lottery_price_class_title">
      <div class="prize-list-cate-wrapper colors" v-if="prize_type_list && prize_type_list.length > 0">
        <div class="prize-list-cate-item" :class="'color-'+item.rarity" v-for="(item, index) in prize_type_list" :key="item.text" v-show="item.list.length > 0"
          :style="{
            'border-top': index != 0 && item.list.length > 0 ? `1px solid ${hexToRgba(cc.box_bg, .2)}` : '' 
          }">
          <span class="tag">{{item.text}}奖品  {{item.probability}}</span>
          <div class="prize-list">
            <div class="prize-item" v-for="prize in item.list" :key="prize.award_id">
              <div class="prize-card">
                <div class="prize-cover"></div>
                <div class="prize-image">
                  <img v-src="prize.img" alt="">
                </div>
                <div class="prize-price">
                  <div class="left">
                    <span class="text1">价值</span>
                    <span class="char" v-if="prize.price">¥</span>
                    <span class="large">{{prize.price || '-'}}</span>
                  </div>
                  <template  v-if="prize.show_type != 2">
                    <div class="split-line">
                      <div class="inner"></div>
                    </div>
                    <div class="right">
                      <div class="inner-text">
                        {{prize.show_type == 0 ? '剩 ' + prize.remain_point : '无限量'}}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <p class="prize-name" :style="{color: cc.lottery_price_class_title ||gc.main_color}">{{prize.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <no-data v-else :color="cc.lottery_price_class_title || gc.main_color" desc="暂时没有奖品哦～" style="padding-bottom: 20px"/>
    </fade-modal>
  </div>
  
</template>

<script type='text/ecmascript-6'>
import FadeModal from './FadeModal'
import { showMessage, executeProtocol } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
import { getDrawLog, openBox } from '_api/activity-common-template'
import Swiper from 'swiper'
import "swiper/swiper.min.css"
export default {
  mixins: [ComponentCommonMixin],
  components: {
    FadeModal
  },
  computed: {
    // 奖品列表
    box_list () {
      return this.cd.box_list || []
    },
    // 获奖列表
    big_prize_list () {
      return this.cd.big_award_list || []
    },
    // 所有奖品，按等级分类
    prize_type_list () {
      const list = [
        {text: '隐秘', rarity: 1, probability: '0.015%', list: []}, 
        {text: '传说', rarity: 2, probability: '0.3%', list: []}, 
        {text: '史诗', rarity: 3, probability: '5%', list: []}, 
        {text: '稀有', rarity: 4, probability: '7%', list: []}, 
        {text: '普通', rarity: 5, probability: '87.685%', list: []}
      ]
      this.box_list.forEach(item => {
        list[item.rarity - 1].list.push(item)
      })
      return list
    },
    lottery_cnt() {
      return this.gd.score_info[this.act_id].score_left
    },
    cur_unlock_count() {
      let start_point = 1707235200000
      return Math.max(Math.ceil((this.cur_time - start_point) / 86400000), 1)
    }
  },
  watch: {
    big_prize_list (n) {
      if (n.length > 0) {
        clearInterval(this._barrage_timer_)
        this._barrage_timer_ = null
        this.$refs['list'].innerHTML = ''
        this.initialBarrage()
      }
    },
  },
  data () {
    return {
      s_counts: 1,
      speed: 100, // 
      canClick: true,
      index: 0,
      lottery_lock: false,
      addTransition: false,
      modal_desc: '',
      front_task_jump_protocol: '',
      record_list: [], // 中奖记录
      award: {},
      notify_content: '',
      // 抽奖结果
      result_index: -1,

      active_index: 0,

      topic_list: [
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.7.jpg', topic_name: '童年记忆返场', topic_id: '116675440' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.8.jpg', topic_name: '2023年度总结', topic_id: '116686180' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.9.jpg', topic_name: '我在黑盒过除夕', topic_id: '116674526' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.10.jpg', topic_name: '新年游戏flag', topic_id: '116687009' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.11.jpg', topic_name: '过年去哪玩', topic_id: '116675605' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.12.jpg', topic_name: '过年必玩', topic_id: '116686554' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.13.jpg', topic_name: '新年愿望清单', topic_id: '116687099' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.14.jpg', topic_name: '2024游戏计划', topic_id: '116675764' },
        { img_url: 'https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/link_poster/2.15.jpg', topic_name: '新年回忆录', topic_id: '116675835' },
      ],
      cur_time: 0,
    }
  },
  mounted () {
    this.cur_time = new Date().getTime()
    this.$nextTick(() => {
      this.initSwiper()
    })
  },
  filters: {
    formatTimestamp (timestamp) {
      if (isNaN(timestamp)) {
        return ''
      }
      var now = Math.ceil((new Date().getTime()) / 1000)
      var delta = Math.ceil((now - timestamp))
      if (delta < 60) {
        return `${delta}秒前`
      } else if (delta < 3600) {
        return `${Math.floor(delta/60)}分钟前`
      } else if (delta < 3600 * 24) {
        return `${Math.floor(delta/3600)}小时前`
      } else {
        return `${Math.floor(delta / (3600*24))}天前`
      }
    }
  },
  methods: {
    initSwiper () {
      this.swiper = new Swiper('.cpt-lottery-activity', {
        loop: true,
        initialSlide: this.cur_unlock_count - 1,
        on: {
          slideChange: (swiper) => {
            this.active_index = swiper.realIndex
          }
        }
      })
    },
    // 交互相关
    getRecords () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (this.lottery_lock) {
        return
      }
      getDrawLog({
        box_machine_id: this.cc.box_machine_id,
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id || this.querys.act_id,
        task_os_type: this.querys.task_os_type,
        client_version: this.querys.version
      }).then(res => {
        if (res.data.status == 'ok') {
          this.record_list = res.data.result.award_list
          this.showRecordModal()
        } else {
          showMessage('failed', res.data.msg)
        }
      })
    },
    startLottery () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (this.querys.client_type == 'acc_mobile') {
        showMessage('failed', '请在小黑盒APP参与此活动')
        return
      }
      if (this.lottery_lock) {
        return
      }
      if (!this.lottery_cnt || this.lottery_cnt <= 0) {
        showMessage('error', '暂无抽奖次数')
        return
      }
      this.lottery_lock = true
      openBox({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id || this.querys.act_id,
        box_machine_id: this.cc.box_machine_id,
        task_os_type: this.querys.task_os_type,
        client_version: this.querys.version
      }).then((res) => {
        if (res.data.status == 'ok') {
          const data = res.data.result
          if (data.type == 'front_task_error') {
            this.front_task_jump_protocol = data.jump_protocol
            this.modal_desc = data.error_msg
          } else {
            this.notify_content = data.award_list[0].name === '谢谢参与' ? '很遗憾，未中奖' : (data.notify_content || '')
            this.award = data.award_list[0]
            this.$set(this.gd.score_info[this.act_id], 'score_left', data.award_list[0].left_count)
            this.result_index = this.box_list.findIndex(item => item.index == data.award_list[0].index) 
            this.showPrizeModal()
          }
        } else {
          showMessage('failed', res.data.msg)
        }
        this.lottery_lock = false
      }).catch(() => {
        this.lottery_lock = false
        showMessage('failed', '请检查您的网络状况')
      })
    },
    handleJumpActivity(topic, index) {
      if(index + 1 > this.cur_unlock_count) return
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.toPost(topic)
    },
    //跳转话题
    toPost (topic) {
      let protocol = {
        protocol_type: 'openRouterPath',
        path: 'bbs/link',
        params: {
          "link_id": topic.topic_id,
        }
      }
      executeProtocol(protocol)
    },
    
    showPrizeModal () {
      this.$refs['prize-modal'].showModal()
    },
    closePrizeModal () {
      this.$refs['prize-modal'].hideModal()
    },
    showRecordModal () {
      this.$refs['record-modal'].showModal()
    },
    closeRecordModal () {
      this.$refs['record-modal'].hideModal()
    },
    showPrizeListModal() {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.$refs['prize-list-modal'].showModal()
    },
    hidePrizeListModal() {
      this.$refs['prize-list-modal'].showModal()
    },
  }
}
</script>

<style lang='less' scoped>
  @import "../style/lottery-item-v2.less";

  /deep/ .colors {
    .prize-box {
      width: 0;
      flex: 1;
      height: 24px;
      margin-left: 16px;
      .prize {
        &.border-color-1 {
          border: 1px solid #F34F34;
        }
        &.border-color-2 {
          border: 1px solid #FCAE1F;
        }
        &.border-color-3 {
          border: 1px solid #7A60FF;
        }
        &.border-color-4 {
          border: 1px solid #00B1FB;
        }
        &.border-color-5 {
          border: 1px solid  #46CC76;
        }
        width: auto;
        max-width: 100%;
        height: 19px;
        display: flex;
        align-items: center;
        padding: 2px 6px 2px 28px;
        position: relative;
        border-radius: 2px;
        float: left;
        max-width: 90%;
        .tag {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: calc(200% + 3px);
          line-height: 30px;
          text-align: center;
          font-size: 18px;
          color: #fff;
          font-weight: 500;
          position: absolute;
          top: -1px;
          left: -1px;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          transform-origin: top left;
          transform: scale(0.5);
        }
        .prize-name {
          height: 14px;
          line-height: 14px;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .color-1 {
      &::before {
        background-color: #F34F34;
      }
      .prize-name,.name {
        color: #F34F34;
      }
      .tag {
        background-color: #F34F34;
      }
    }
    .color-2 {
      &::before {
        background-color: #FCAE1F;
      }
      .prize-name,.name {
        color: #FCAE1F;
      }
      .tag {
        background-color: #FCAE1F;
      }
    }
    .color-3 {
      &::before {
        background-color: #7A60FF;
      }
      .prize-name,.name {
        color: #7A60FF;
      }
      .tag {
        background-color: #7A60FF;
      }
    }
    .color-4 {
      &::before {
        background-color: #00B1FB;
      }
      .prize-name,.name {
        color: #00B1FB;
      }
      .tag {
        background-color: #00B1FB;
      }
    }
    .color-5 {
      &::before {
        background-color: #46CC76;
      }
      .prize-name,.name {
        color: #46CC76;
      }
      .tag {
        background-color: #46CC76;
      }
    }
  }
  .cpt-lottery-simple {
    width: 100%;
    padding-top: 184%;
    position: relative;
    background: url('https://imgheybox.max-c.com/oa/2024/02/07/35fcddf478457f2f3fa6d47f6137ec4c.png?imageMogr2/format/webp/quality/75/ignore-error/1') no-repeat center / cover;
    .btn-bottom-wrapper {
      width: 100%;
      height: 53px;
      padding: 0 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 15.2%;
      .btn-record {
        width: 17.6%;
        padding-top: 6.4%;
        margin-right: 6px;
        background: url('https://static.max-c.com/static/heybox/webapp/activity/draw-lots-2024/record-btn.png?imageMogr2/format/webp/quality/75/ignore-error/1') no-repeat center / cover;
      }
      .btn-award-pool {
        width: 17.6%;
        padding-top: 6.4%;
        margin-left: 6px;
        background: url('https://static.max-c.com/static/heybox/webapp/activity/draw-lots-2024/prize-list-btn.png?imageMogr2/format/webp/quality/75/ignore-error/1') no-repeat center / cover;
      }
      .btn-draw-box {
        width: 55.2%;
        position: relative;
        .rest-count-desc {
          width: 100%;
          height: 13px;
          position: absolute;
          bottom: -16px;
          left: 0;
          p {
            width: 200%;
            height: 26px;
            line-height: 26px;
            text-align: center;
            font-size: 18px;
            color: #F0924E;
            transform: scale(0.5);
            transform-origin: 0 0;
          }
        }
        .btn-draw {
          width: 100%;
          padding-top: 25.6038647%;
          background: url('https://static.max-c.com/static/heybox/webapp/activity/draw-lots-2024/lottery-btn.png?imageMogr2/format/webp/quality/75/ignore-error/1') no-repeat center / cover;
          &.disable {
            opacity: 0.7;
          }
        }
      }
    }
    .swiper-mask {
      width: 95.2%;
      padding-top: 57.8666667%;
      background: url('https://imgheybox.max-c.com/oa/2024/01/24/fb08759c1bc456f7961a5b94268bbc77.png?imageMogr2/format/webp/quality/75/ignore-error/1') no-repeat center / cover;
      position: absolute;
      top: 44.5%;
      left: 2.4%;
      z-index: 2;
      pointer-events: none;
    }
    .activity-dot {
      width: 100%;
      height: 10px;
      position: absolute;
      top: 72.1%;
      left: 0;
      z-index: 2;
      display: flex;
      justify-content: center;
      .dot-item {
        width: 10px;
        height: 10px;
        position: relative;
        margin: 0 4px;
        &.active {
          &::after {
            width: 14px;
            height: 14px;
            background-color: #6E1F00;
            border-radius: 2px;
          }
        }
        &::after {
          content: '';
          display: block;
          width: 8px;
          height: 8px;
          border: 2px solid #6E1F00;
          transform: translate(-50%, -50%) scale(0.5) rotate(45deg);
          transform-origin: center center;
          position: absolute;
          top: 50%;
          left: 50%;
          box-sizing: border-box;
          border-radius: 1px;
        }
      }
    }
    .activity-list {
      width: 82.4%;
      padding-top: 44.018241%;
      position: absolute;
      top: 47%;
      left: 8.8%;
      z-index: 1;
      .swiper-container {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        .activity-item {
          position: relative;
          .locked-poster {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background: rgba(138, 24, 11, 0.80);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .label {
              text-align: center;
              text-shadow: 1px -1px 0 #A31100, 1px -1px 0 #A31100, -1px 1px 0 #A31100, 1px 1px 0 #A31100;
              font-family: "SourceHanSerifCN-Heavy";
              font-size: 17px;
              font-weight: 900;
              line-height: 24px;
              color: #FFEDBB;
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .btn-lottery {
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      height: 44px;
      margin-top: 14px;
      line-height: 44px;
      text-align: center;
      font-weight: 500;
      font-size: 15px;
      width: 100%;
    }
    .record-wrapper {
      width: 100%;
      border-radius: 10px;
      position: relative;

    }
    .close-icon {
      width: 16px;
      height: 16px;
      display: block;
      object-fit: contain;
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 10;
    }
    .record-wrapper, .prize-modal-wrapper {
      width: 100%;
      position: relative;
      .title-img {
        position: absolute;
        top: 7.5%;
        height: 12.03%;
        left: 50%;
        transform: translate(-50%);
      }
      .main-content {
        width: 100%;
      }
      .prize-area {
        width: 40%;
        padding-bottom: 40%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .prize-bg {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .prize-img {
          width: 57%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .prize-name {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0px;
          width: 73px;
          min-height: 28px;
          border-radius: 20px;
          border: 1px solid #FFB35A;
          background: linear-gradient(180deg, #FFC968 0%, #FFDEA5 100%);
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          .text {
            max-width: 50px;
            color: #723F00;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 10px;
            font-weight: 500;
            line-height: 11px;
            word-break: break-all;
          }
        }
      }
      .record-content {
        height: 50%;
        position: relative;
        z-index: 2;
        position: absolute;
        top: 25%;
        left: 0;
        width: 100%;
        .record-list {
          width: 100%;
          margin: 2px 0 20px;
          max-height: calc(100% - 36px);
          padding: 0 12px;
          overflow-y: scroll;
          overflow-x: hidden;
          .record-item {
            width: 100%;
            height: 24px;
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .desc {
              height: 16px;
              line-height: 16px;
              color: #8C9196;
              opacity: .7;
              font-size: 12px;
            }
            .time-desc {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .no-record {
            width: 100%;
            height: 30px;
            line-height: 24px;
            font-size: 13px;
            color: #8C9196;
            text-align: center;
          }
        }
        .distribute-desc {
          line-height: 16px;
          font-size: 11px;
          margin: 14px 0 0;
          text-align: center;
        }
      }
      .btn-done {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 5.6%;
        height: 13%;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }

    .prize-list-cate-wrapper {
      width: 100%;
      height: 100%;
      padding: 0 8px 0 14px;
      -webkit-overflow-scrolling: touch;
      .prize-list-cate-item {
        background-color: transparent;
        border: none;
        &.color-1 {
          .prize-card::after {
            border: 1px solid rgb(235, 63, 39);
          }
          .tag {
            background: linear-gradient(90deg, #EB3F27 0%, rgba(235, 63, 39, 0) 100%);
          }
          .prize-cover {
            // background: linear-gradient(360deg, rgba(235, 63, 39, 0.4) 0%, rgba(235, 63, 39, 0) 100%);
            background: rgba(235, 63, 39, 0.4);
          }
        }
        &.color-2 {
          .prize-card::after {
            border: 1px solid rgb(252, 174, 31);
          }
          .tag {
            background: linear-gradient(90deg, #FCAE1F 0%, rgba(252, 174, 31, 0) 100%);
          }
          .prize-cover {
            // background: linear-gradient(360deg, rgba(253, 160, 20, 0.4) 0%, rgba(253, 160, 20, 0) 100%);
            background: rgba(253, 160, 20, 0.4);
          }
        }
        &.color-3 {
          .prize-card::after {
            border: 1px solid rgb(122, 96, 255);
          }
          .tag {
            background: linear-gradient(90deg, #7A60FF 0%, rgba(122, 96, 255, 0) 100%);
          }
          .prize-cover {
            // background: linear-gradient(360deg, rgba(122, 96, 255, 0.4) 0%, rgba(122, 96, 255, 0) 100%);
            background: rgba(122, 96, 255, 0.4);
          }
        }
        &.color-4 {
          .prize-card::after {
            border: 1px solid rgb(0, 177, 251);
          }
          .tag {
            background: linear-gradient(90deg, #00B1FB 0%, rgba(0, 177, 251, 0) 100%);
          }
          .prize-cover {
            // background: linear-gradient(360deg, rgba(0, 177, 251, 0.4) 0%, rgba(0, 177, 251, 0) 100%);
            background: rgba(0, 177, 251, 0.4);
          }
        }
        &.color-5 {
          .prize-card::after {
            border: 1px solid rgb(46, 173, 87);
          }
          .tag {
            background: linear-gradient(90deg, #2EAD57 0%, rgba(46, 173, 87, 0) 100%);
          }
          .prize-cover {
            // background: linear-gradient(360deg, rgba(46, 173, 87, 0.4) 0%, rgba(46, 173, 87, 0) 100%);
            background: rgba(46, 173, 87, 0.4);
          }
        }
        // &:not(:first-child);
        //   margin-top: 4px;
        //   width: 100%;
        //   position: relative;
        //   padding: 22px 8px 9px 10px;
        // &::before;
        //   content: '';
        //   width: 4px;
        //   height: calc(100% - 4px);
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        .tag {
          display: block;
          padding: 2px 0 2px 6px;
          color: #FFFFFF;
          font-weight: 500;
          font-size: 12px;
        }
        .prize-list {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          margin-top: 6px;
          margin-bottom: 14px;
          overflow: hidden;
          .prize-item {
            width: calc(33.333333% - 6px);
            margin: 0 6px 10px 0;
            .prize-name {
              margin-top: 3px;
              line-height: 17px;
              font-size: 12px;
              // color: #D0D2D4;
            }
            .prize-card {
              position: relative;
              width: 100%;
              height: 80px;
              background: rgba(#14191E, 0.8);
              border-radius: 5px;
              &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 200%;
                height: 200%;
                transform: scale(.5);
                transform-origin: 0 0;
                box-sizing: border-box;
                border-radius: 10px;
              }
              .prize-cover {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 24px;
                border-radius: 0 0 5px 5px;
              }
              .prize-image {
                width: 100%;
                height: 56px;
                overflow: hidden;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
              .prize-price {
                height: 24px;
                position: relative;
                color: #ffffff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 0 0 5px 5px;
                padding: 0 10px;
                width: calc((((100vw - 28px) / 3) - 6px) * 2);
                transform-origin: left;
                transform: scale(0.5);
                .left {
                  height: 48px;
                  font-size: 18px;
                  display: flex;
                  align-items: center;
                  .text1 {
                    margin-right: 8px;
                  }
                  .char {
                    margin-right: 2px;
                  }
                  span {
                    display: inline-block;
                    vertical-align: top;
                    white-space: nowrap;
                    &.large {
                      position: relative;
                      font-size: 22px;
                      font-weight: 500;
                    }
                  }
                }
                .split-line {
                  flex: 1;
                  width: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .inner {
                    width: 1px;
                    height: 20px;
                    background: rgba(255, 255, 255, 0.2);
                  }
                }
                .right {
                  height: 48px;
                  font-size: 18px;
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  position: relative;
                  .inner-text {
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 26px;
                    color: #FFFFFF;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .subscribe-wrapper {
    width: 100%;
    h2 {
      margin-top: 8px;
    }
    .btn-wrapper {
      width: 100%;
      height: 32px;
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      padding: 0 6px;
      .btn {
        width: 88px;
        height: 32px;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        font-size: 16px;
        font-weight: normal;
        &.btn-cancel {
          opacity: 0.5;
        }
      }
    }
    .btn-wrapper {
      width: 100%;
      height: 42px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .btn {
        width: 125px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        font-size: 16px;
        &.btn-cancel {
          background-color: #f1f2f3;
          color: #64696e;
        }
        &.btn-confirm {
          background-color: #14191e;
          color: #fff;
        }
      }
    }
  }

@font-face {
  font-family: "SourceHanSerifCN-Heavy";
  src: url("https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/SourceHanSerifCN-Heavy.woff") format("woff"),
    url("https://static.max-c.com/static/heybox/webapp/activity/20240204-lottery-simple/SourceHanSerifCN-Heavy.ttf") format("truetype");
  font-display: swap;
  font-weight: 900;
}

</style>